/*
This function is used to handle error codes that are returned from the API.
The error codes are as follows:

- 1000 - 1999: Ory exceptions
 - 1000: Exception when we tried to get JWT from Ory (catch-all)
 - 1001: JWT received from Ory failed validation
- 2000 - 2999: Request errors
 - 2000: Token is expired
 - 2001: Token is invalid (catch-all when we can't decode the token)
 - 2002: JWT is invalid
 - 2003: No JWT token found in request cookies
- 3000 - 3999: Permissions errors
 - 3000: User didn't give us the openid permission
 - 3001: User denied access to their openid
 - 3002: User is blocked and can't login

 It takes in an error code and returns a string that can be used to display
 the error to the user.
 */

export function handleErrorCode(errorCode: string | string[]) {
  switch (errorCode) {
    case '1000':
    case '1001':
      return 'An error occurred when trying to log you in. Please try again.';
    case '2000':
    case '2003':
      return 'Your session has expired. Please log in again.';
    case '2001':
    case '2002':
      return 'An error occurred, please log in again.';
    case '3000':
    case '3001':
      return "You must give PyScript permission to access your openid. Please log in again and select the 'openid' permission.";
    case '3002':
      return 'Unable to log you in.';
    default:
      return null;
  }
}
